<template>

  
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">

      <Basic :form="form" :method="method"></Basic> 
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import Basic from './part/Basic.vue';
  import cardApi from '@/api/card.js';
  export default {
    components: {

      Basic,
    
    },
    data() {
      return {
        method:'add',
        /*切换菜单*/
        // activeIndex: '1',
        /*form表单数据*/
        form: {
          supply_id: '',
          status: 1,
          name: '',
          mobile: '',
          wechat:'',
          email:'',
          images:[],
          video:"",
          introduce:"",
          labelList:[],
          occupation:"",
          category_id:null,
          province_id: '',
          city_id: '',
          region_id: '',
          introduce:'',
          status:1,
          displayorder:0,
          more_supply:'',
          is_super:0,
          user_id:0,
          user:{
            avatarUrl:''
          },
        },
        typelist:[],
        supplyList: [],
        /*是否正在加载*/
        loading:false,
       
      };
    },
    created() {
      this.form.supply_id =  this.$route.query.supply_id;
      this.getIsSuper();
    },
    methods: {
      getIsSuper(){
        var self = this;
        cardApi.getIsSuper({
          supply_id: self.form.supply_id 
        }).then(data => {
          self.form.is_super = data.data.is_super;
          self.form.user_id = data.data.user_id;
        })
        .catch(error => {
        });
      },
      /*添加用户*/
      onSubmit() {
        let self = this;
        let form = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            cardApi.addCard(form, true)
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '恭喜你，添加成功',
                    type: 'success'
                  });
                  self.$router.push('/plus/card/index?supply_id='+self.form.supply_id);
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },

       /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },


    }

  };
</script>

<style lang="scss" scoped>
  .basic-setting-content {}

  .product-add {
    padding-bottom: 50px;
  }

  .img {
    margin-top: 10px;
  }

  .edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/card/cardlist/add.vue